import { createSlice } from '@reduxjs/toolkit'

export interface SignUpSliceState {
  userAuth: {
    email: string
    authToken: string
    phoneNumber: string
  }
}

export const signUpSliceInitialState: SignUpSliceState = {
  userAuth: {
    email: '',
    authToken: '',
    phoneNumber: '',
  },
}

const signUpSlice = createSlice({
  name: 'signUp',
  initialState: signUpSliceInitialState,
  reducers: {
    setUserCredentials: (state, action) => {
      const userAuth = action.payload
      state.userAuth.email = userAuth.email
      state.userAuth.authToken = userAuth.authToken
      state.userAuth.phoneNumber = userAuth.phoneNumber
    },
    setUserPhoneNumber: (state, action) => {
      state.userAuth.phoneNumber = action.payload.phoneNumber
    },
    clearUserCredentials: (state) => {
      state.userAuth = {
        email: '',
        authToken: '',
        phoneNumber: '',
      }
    },
    clearSignUpState: (state) => {
      state.userAuth = signUpSliceInitialState.userAuth
    },
  },
})
export const {
  setUserCredentials,
  clearUserCredentials,
  clearSignUpState,
  setUserPhoneNumber,
} = signUpSlice.actions

export default signUpSlice.reducer
